import axios from 'axios'
import { BACKEND_URL } from '../config';

const _axios = axios.create({
  baseURL: BACKEND_URL,
  headers: { 'Content-Type': 'application/json' }
})

class BuildingService {
  getBuildings() {
    return _axios.get(`api/buildings`);
  }

  getLocators(buildingId) {
    return _axios.get(`api/buildings/${buildingId}/locators`);
  }
  
  getAccessPoints(buildingId) {
    return _axios.get(`api/buildings/${buildingId}/access-points`);
  }

  reloadMaps() {
    return _axios.post(`api/floors/reload-maps`);
  }

  clearCache() {
    return _axios.post(`api/buildings/clear-cache`);
  }
}

export const buildingService = new BuildingService();
